import Head from "next/head";

export function OrganizationSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Ledgerowl",
    url: "https://ledgerowl.com.au",
    logo: "https://ledgerowl.com.au/favicon.png",
    description:
      "AI-powered bookkeeping and accounting service for Australian businesses with human-verified accuracy",
    areaServed: "AU",
    sameAs: [],
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </Head>
  );
}

export function LocalBusinessSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    name: "Ledgerowl",
    description:
      "AI bookkeeping and BAS agent service in Sydney, Australia. Human-verified accounting with automated BAS lodgement for small businesses and startups.",
    url: "https://ledgerowl.com.au",
    logo: "https://ledgerowl.com.au/favicon.png",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Sydney",
      addressRegion: "NSW",
      addressCountry: "AU",
    },
    areaServed: [
      { "@type": "City", name: "Sydney" },
      { "@type": "Country", name: "Australia" },
    ],
    serviceType: [
      "AI Bookkeeping",
      "BAS Lodgement",
      "Accounting",
      "Tax Compliance",
    ],
    priceRange: "$199 - $1799/month",
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </Head>
  );
}

export function ServiceSchema({ services }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: services.map((service, index) => ({
      "@type": "ListItem",
      position: index + 1,
      item: {
        "@type": "Service",
        name: service.name,
        description: service.description,
        provider: {
          "@type": "Organization",
          name: "Ledgerowl",
        },
        areaServed: "AU",
        ...(service.price && {
          offers: {
            "@type": "Offer",
            price: service.price,
            priceCurrency: "AUD",
            priceSpecification: {
              "@type": "UnitPriceSpecification",
              price: service.price,
              priceCurrency: "AUD",
              unitText: "MONTH",
            },
          },
        }),
      },
    })),
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </Head>
  );
}

export function FAQSchema({ items }) {
  if (!items || items.length === 0) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </Head>
  );
}
